import { isStateScheduledOrLower } from "module/maintenanceTask/helper/isStateScheduledOrLower";
import { MaintenanceTaskInterface } from "module/maintenanceTask/types";

interface Props {
  isMaintenanceTaskOpen: boolean;
  canEditMaintenanceTask: boolean;
  maintenanceTask: MaintenanceTaskInterface;
}

export const canRemoveMaintenanceTaskAssistant = ({
  isMaintenanceTaskOpen,
  canEditMaintenanceTask,
  maintenanceTask,
}: Props): boolean =>
  isMaintenanceTaskOpen &&
  canEditMaintenanceTask &&
  isStateScheduledOrLower(maintenanceTask) &&
  maintenanceTask.assistantType != null;
